import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { ContentCard } from 'components/Card';
import { getTrans } from 'modules/i18n';
import { CVBuilderFormValues, ExperienceEntry } from 'utils/cv-form-db';
import { StepProgressIndicator } from '../../components/StepProgressIndicator';
import { ProfessionalExperienceDetailsList } from './ProfessionalExperienceDetailsList';
import { ExperienceForm } from './ProfessionalExperienceForm';

interface ProfessionalExperienceContentProps {
  isFormOpen: boolean;
  isEditing: boolean;
  editingItem: ExperienceEntry | null;
  onAdd: (item: ExperienceEntry) => void;
  onEdit: (item: ExperienceEntry) => void;
  onCancel: () => void;
  onAddClick: () => void;
  onEditClick: (index: number) => void;
  onDeleteClick: (index: number) => void;
}

export const ProfessionalExperienceContent = ({
  isFormOpen,
  isEditing,
  editingItem,
  onAdd,
  onEdit,
  onCancel,
  onAddClick,
  onEditClick,
  onDeleteClick
}: ProfessionalExperienceContentProps) => {
  const { values } = useFormikContext<CVBuilderFormValues>();

  return (
    <>
      <ContentCard
        title={getTrans('cvBuilderPage.professionalExperience.title')}
        titleVariant="h4"
      >
        <Box sx={{ mb: 2 }}>
          <StepProgressIndicator
            showPercentage={true}
            size="medium"
            variant="compact"
          />
        </Box>
      </ContentCard>
      {isFormOpen ? (
        <ExperienceForm
          mode={isEditing ? 'edit' : 'add'}
          initialValues={editingItem || undefined}
          onSubmit={isEditing ? onEdit : onAdd}
          onCancel={onCancel}
        />
      ) : (
        <ProfessionalExperienceDetailsList
          values={values}
          onAddClick={onAddClick}
          onEditExperience={onEditClick}
          onDeleteExperience={onDeleteClick}
        />
      )}
    </>
  );
};
